// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610190905/js/" + chunkId + "." + {"44":"dd2b81e4","225":"fa6a5067","481":"e26fb3cf","486":"eae1ffe4","770":"c4e6acef"}[chunkId] + ".0.09414211576074372.chunk.js";
};